module.exports = __webpack_public_path__ + "img/user.c19a9e96.png";